module.exports = __webpack_public_path__ + "assets/a6cac79df310e7f0ee98db0185316a97.png";